export { default } from './Historia';
